'use client'

export {default as TambahCustomer} from "./tambah-customer"
export {default as EditCustomer} from "./edit-customer"

